import http from "./apiClient";

export const listClassroomDrafts = (schoolYearId) => {
  const params = schoolYearId ? { schoolYearId } : undefined;
  return http.get("/classroom-drafts", { params });
};

export const createClassroomDraft = (payload) =>
  http.post("/classroom-drafts", payload);

export const fetchClassroomDraftById = (id) =>
  http.get(`/classroom-drafts/${encodeURIComponent(id)}`);

export const deleteClassroomDraft = (id) =>
  http.delete(`/classroom-drafts/${encodeURIComponent(id)}`);
